module.exports = __webpack_public_path__ + "static/button-caseandpunctuation-dont-c02196a00279bd046efa28351f5c9812.png";